import { openComponentInPopup } from "../common";
import Form from "../form";
import { ActionCreator, AjaxDispatcher } from "../ajax-dispatcher";
import { initCompanyProfile } from "../main";
import { IPopup, PopupWidth } from "../popup";

export class CompanyProfile {
    private popup: IPopup;

    constructor() {
        this.init();
    }

    private init(): void {
        const baseElement = document.querySelector('[data-component=CustomerCompanyProfile]');
        const actionButtons = Array.from(baseElement.querySelectorAll('[data-popup-component]'));
        this.addEventListeners(actionButtons);
    }

    private addEventListeners(elements: Element[]): void {
        elements.forEach(element => {
            element.addEventListener('click', async () => await this.openPopup(element))
        });
    }

    private async openPopup(element: Element): Promise<void> {
        const componentName = element.getAttribute('data-popup-component');

        this.popup = await openComponentInPopup(componentName, [{ key: 'type', value: 'company' }], { id: 'edit-company-form-popup', width: PopupWidth.Medium });
        this.subscribeForm(componentName);
    }

    private subscribeForm(componentName: string): void {
        const formElement = document.querySelector('[data-popup] form') as HTMLFormElement;

        const actionUrl = formElement.getAttribute('action');
        const form = new Form(actionUrl, formElement, 
            () => this.onSuccess(),
            (html: string) => this.onModelError(componentName, html));

        form.subscribeAndProcess();
    }

    private onSuccess(): void {
        this.popup.close();
        const action = new ActionCreator().reloadComponent('CustomerCompanyProfile');
        action.successAction = initCompanyProfile;
        new AjaxDispatcher().dispatchGetAction(action);
    }

    private onModelError(componentName: string, html: string): void {
        const viewcomponent = document.querySelector(`[data-component=${componentName}]`);
        viewcomponent.innerHTML = html;
        this.subscribeForm(componentName);
    }
    
}
